module.exports = __webpack_public_path__ + "media/subway/E-4e49b954.png";